/*
Use this file to import custom js files from assets-extend/js or npm packages

Example:
import "./js/navigation-desktop.js";
*/

import "unfetch/polyfill";
import "es6-promise/auto";
import objects from "./js/core/objects";
import translations from "@savchukoleksii/shopify-theme-translations-tool";
import settings from "@savchukoleksii/shopify-theme-settings-tool";
import * as sections from "@shopify/theme-sections";

import { store } from "./js/vue/store";
import { ACTION_INIT_WISHLIST } from "./js/vue/store/wishlist/wishlist";
import { ACTION_INIT_CART } from "./js/vue/store/cart/cart";

import { addCurrentProductToRecentlyViewedProducts } from "./js/core/helpers/recentlyViewedProducts";

const DOMContentLoadedPromise = new Promise((resolve) => {
    document.addEventListener("DOMContentLoaded", async () => {
        resolve();
    });
});

import * as bodyScrollLock from "body-scroll-lock";
global.bodyScrollLock = bodyScrollLock;

import $ from "jquery";
import initWishlistCountUpdate from "./js/components/general/wishlist-count";
import initCollectionWishlist from "./js/components/general/wishlist-collections";

global.jQuery = $;
global.$ = $;

window.theme = window.theme || {};

/*================ Components ================*/
require("./js/components/lazy-load-images");
require("./js/components/general/accordion");
require("./js/components/general/custom-select");
require("./js/components/general/dropdown-menu");
require("./js/components/general/smooth-scroll");
require("./js/components/general/kpm-plus");

require("./js/components/quantity-selector/quantity-selector");
require("./js/components/slider/slider");
require("./js/components/medallions-slider/medallions-slider");
require("./js/components/checkout/checkout");

/*================ Sections ================*/
require("./js/sections/header");
require("./js/sections/minicart");
require("./js/sections/mini-cart");
require("./js/sections/slider");
require("./js/sections/store-locations");
require("./js/sections/pdp-newsletter");
require("./js/sections/top-slider");
require("./js/sections/collections-slider");
require("./js/sections/images-slider");
require("./js/sections/account/personal-information");
require("./js/sections/account/register");
require("./js/sections/account/reset");
require("./js/sections/customizable-product.js");
require("./js/sections/account/newsletter-preferences");
require("./js/sections/wishlist");
require("./js/sections/cart");
require("./js/sections/weiss-club");
require("./js/sections/booking-events");
/*================ Templates ================*/
require("./js/templates/customers-addresses");
require("./js/templates/customers-login");
require("./js/templates/product");
require("./js/templates/collection");

// leave toolbar at the end of file temporary
require("./js/sections/toolbar");

(async () => {
    try {
        await Promise.all([
            translations.load(),
            settings.load(),
            objects.load(),
            DOMContentLoadedPromise
        ]);

        document.dispatchEvent(new CustomEvent("theme:all:loaded"));
    } catch (error) {}

    await Promise.all([
        store.dispatch(`cart/${ACTION_INIT_CART}`),
        store.dispatch(`wishlist/${ACTION_INIT_WISHLIST}`)
    ]);

    addCurrentProductToRecentlyViewedProducts();
    initWishlistCountUpdate();
    initCollectionWishlist();

    sections.load("*");
})();


// Y1 Scripts
import Alpine from 'alpinejs';
//import "./js/core/iodine-config.js";
//import "./js/core/date-picker.js";
import "./js/global-paths.js";

window.Alpine = Alpine;

Alpine.start();